import React, { useEffect, useState } from 'react';
import RequestHeader from './RequestHeader';
import RequestForm from './RequestForm';
import RequestFooter from './RequestFooter';
import ReviewSummaryCard from './ReviewSummaryCard';
import style from './style.module.css';
import { INFORMATION_REQUEST_API } from '../../config';
import axios from 'axios';

const CustomerRequest = ({ reviewId, lables, languagesOptions, overrideLanguage, review, logoUrl }) => {
    const userLang = navigator.language || navigator.userLanguage;
    const default_language = userLang.includes('ar') ? 'ar' : 'en';
    const [language, setDefaultLanguage] = useState(default_language);
    const [showRequestForm, setShowRequestForm] = useState(true);
    const onSelectLanguage = language => {
        setDefaultLanguage(language);
    };
    const onSubmitCustomerRequest = values => {
        sendData(values)
    }
    const sendData = data => {
        axios.patch(`${INFORMATION_REQUEST_API}${reviewId}`, data).then(() => setShowRequestForm(false))
    }

  useEffect(() => {
    if (overrideLanguage) {
      setDefaultLanguage(overrideLanguage);
    }
  }, [overrideLanguage]);

  return (
        <div className={style.customerRequestWrapper}>
            <div className={style.outerCard}>
                <RequestHeader languagesOptions={languagesOptions} value={language} onSelect={onSelectLanguage} />
                <div className={style.hero}>
                    <div className={style.logoBadge}>
                        <img className={style.heroLogo} src={logoUrl} alt='' />
                    </div>
                    <h1 className={style.heroTitle}>{lables?.customerInformationRequest?.[language]}</h1>
                    <p className={style.heroSubtext}>{lables?.informationRequestMessage?.[language]}</p>
                </div>
                <ReviewSummaryCard
                    review={review}
                    companyName={lables?.companyName?.[language] || review?.locationTitle}
                    logoUrl={logoUrl}
                    language={language}
                    reviewedLabel={lables?.reviewSummaryReviewedLabel?.[language] || 'Reviewed'}
                    reviewTypeLabel={lables?.reviewSummaryReviewTypeLabel?.[language] || 'review'}
                    responseFromLabel={lables?.reviewSummaryResponseFromLabel?.[language] || 'Response from'}
                    ownerLabel={lables?.reviewSummaryOwnerLabel?.[language] || 'Owner'}
                />
                <RequestForm
                    onSubmitCustomerRequest={onSubmitCustomerRequest}
                    namePlaceholder={lables?.namePlaceholder?.[language]}
                    email={lables?.emailPlaceholder?.[language]}
                    mobile={lables?.mobilePlaceholder?.[language]}
                    additionalDetailsPlaceholder={lables?.additionalDetailsPlaceholder?.[language]}
                    requiredMessage={lables?.requiredMessage?.[language]}
                    submitButton={lables?.giveMoreDetailsButtonWithoutFeedback?.[language]}
                    successMessage={lables?.successMessage?.[language]}
                    validateEmail={lables?.validateEmail?.[language]}
                    showRequestForm={showRequestForm}
                />
                <RequestFooter powered={lables?.powered ? lables.powered[language] : 'Powered by'} />
            </div>
        </div>
    );
};

export default CustomerRequest;
